import FuneralLearnMore from "../../Spiritual/LearnMore/FuneralLearnMore";
import StorytellingLearnMore from "../../Spiritual/LearnMore/StorytellingLearnMore";
import SpiritualNeedsLearnMore from "../../Spiritual/LearnMore/SpiritualNeedsLearnMore";
import ComingSoonPlaceholder from "../../../../Assessment/ComingSoonPlaceholder";
import EndOfLifeCareLearnMore from "../../Spiritual/LearnMore/EndOfLifeCareLearnMore";
import MakingPeaceLearnMore from "../../Spiritual/LearnMore/MakingPeaceLearnMore";
import FaithBasedProgramsLearnMore from "../../Spiritual/LearnMore/FaithBasedProgramsLearnMore";
import PrayerWithParentsLearnMore from "../../Spiritual/LearnMore/PrayerWithParentsLearnMore";
import ChurchContactsLearnMore from "../../Spiritual/LearnMore/ChurchContactsLearnMore";
import DiscoveringPurposeLearnMore from "../../Spiritual/LearnMore/DiscoveringPurposeLearnMore";

export interface SpiritualLearnMoreFactoryProps {
  infoSlideIndex: number;
}

export const SpiritualLearnMoreFactory: React.FC<
  SpiritualLearnMoreFactoryProps
> = ({ infoSlideIndex }) => {
  switch (infoSlideIndex) {
    case 0: {
      return (
        <StorytellingLearnMore />
      );
    }
    case 1: {
      return (
        <FuneralLearnMore />
      );
    }
    case 2: {
      return (
        <EndOfLifeCareLearnMore />
      );
    }
    case 3: {
      return (
        <MakingPeaceLearnMore />
      );
    }
    case 4: {
      return (
        <SpiritualNeedsLearnMore />
      );
    }
    case 5: {
      return (
        <FaithBasedProgramsLearnMore />
      );
    }
    case 6: {
      return (
        <DiscoveringPurposeLearnMore/>
      );
    }
    case 7: {
      return (
        <PrayerWithParentsLearnMore />
      );
    }
    case 8: {
      return (
        <ChurchContactsLearnMore />
      );
    }
    default: {
      return (
        <ComingSoonPlaceholder />
      );
    }
  }
};
